import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconStaffSvg }  from '../../assets/icons/icon_terminal_device_blue.svg';

const TerminalDeviceIcon=(props)=>{
    return <Icon component={() => <IconStaffSvg />} {...props}/>
}

export default TerminalDeviceIcon;